import { axios } from '@/utils/request'

const api = {
  yeyuList: '/adminapi/Yeyudengji/getMemberList',
}

export default api

export function getyeyuList(parameter) {
  return axios({
    url: api.yeyuList,
    method: 'get',
    params: parameter
  })
}
